export const DEFAULT_DOCUMENT_TITLE = 'TCC online';

export default function resolveDocumentTitle(
    isWhitelabel: boolean,
    companyName: string | null | undefined,
): string {
    if (isWhitelabel && companyName) {
        return companyName;
    }

    return DEFAULT_DOCUMENT_TITLE;
}
